export default "__VITE_ASSET__CXre6A5k__"